import React, {useContext} from "react"
import Helmet from "react-helmet"

import Layout from '../components/layout'
import Header from '../components/Header'
import Section, { TextSection, BackgroundSection, Button } from '../components/Section'


import pic01 from '../assets/images/pic01.jpg'
import pic02 from '../assets/images/pic02.jpg'
import pic03 from '../assets/images/pic03.jpg'
import pic04 from '../assets/images/pic04.jpg'

import { getMediaHeader, getStaticPageData } from "../lib/API"
import { useData, useLocalData } from "../lib/hooks"
import Link from "../components/Link"

import BannerSection from "../components/BannerSection"
import VideoHighlight from "../components/VideoHighlight"

// import LiveSermonImage from '../assets/images/home/live-camera.jpg'
// import LiveSermonImage from '../assets/images/general/8.jpg'
import LiveSermonImage from "../assets/images/church-interior/10.jpg"
import Camera from "../assets/images/fujifilm/381.jpg"
import Online from "../assets/images/fujifilm/106.jpg"




// import AudioImage from '../assets/images/home/audio.jpg'
import AudioImage from '../assets/images/core/Front5_Cropped.jpg'
import BannerContext from "../lib/context"



const MediaPage = () => {
    const siteTitle = "Blackheath and Charlton Baptist Church"

    const pageName = 'media-banners'
    // const pageData = useLocalData( getStaticPageData, pageName, pageName )
    const pageData = useContext( BannerContext )[pageName]
    const { header, banners } = pageData || { header: null, banners: null }
    const headerImages = header ? header.images : [] 
    const headerTitle = header ? header.title : 'Services & Media'
    
    // const headerImages = useData( getMediaHeader )
    // const headerTitle = "Services and Media"
    const headerIcon = <span className="icon major"><i className="fas fa-film"></i></span>
    const headerButtons = [
        { url: "/media#one", text: "View Sermons" }
    ]

    return (
            
        <div id='media-page'>
            <Helmet title={`${siteTitle} - Services and Media`} />
            <Header images={[Camera]} headerTitle={headerTitle} tint={0.1} headerButtons={headerButtons} />

            <TextSection 
                id="services" 
                title="Sunday Service"
                style="blue special"
                // background={[ Online ]}
                description={`Join us for our <b>Sunday Morning Service at BCB Church</b>, as we come together in worship to experience the <b>presence of God</b>, and receive from His Word.

                    Whether you are new to church, exploring faith, or looking for a place to grow spiritually, you are warmly welcome. 
                    At BCB Church, we believe that <b>God blesses those who seek Him wholeheartedly</b>.

                    We are a <b>vibrant community of believers</b> committed to meaningful worship and <b>practical Bible teaching that speaks to everyday life</b>.

                    If you would like <b>someone to pray with you</b>, we would love to support you. Please feel free to get in touch with our team.

                    <b>Everyone is welcome. We look forward to worshipping with you</b>.`
                }

            />


            <TextSection 
                id="live-sermons" 
                title="Online Service"
                style="style1"
                background={[ Online ]}
                description="Join us online as we gather for worship, prayer, and the teaching of God’s Word. Click the button below to watch our live service."
                buttons={[ { url: 'https://www.youtube.com/channel/UCo1-ajfKW62orxAK4TPkQ3Q/live', external: true, text: 'Watch Now', style: 'transparent-button' } ]}
                tint={0.6}
                blur={0}

            />

            <VideoHighlight />   

            {/* <BackgroundSection 
                id="audio-section" 
                title="Audio Sermons"
                className='style2'
                description={`Find all our audio sermons here, where you can listen and be enriched by the word of God`}
                background={[ AudioImage ]}
                buttons={[ { url: '/media/audio', special: false, text: 'Listen',  style: 'transparent-button' } ]}
                tint={0.55}
                blur={0.05}
                alt

            /> */}

            <TextSection 
                id="audio-section" 
                title="Prayer Meeting Audio"
                className='style2'
                description={`Find all our prayer meeting audios here, where you can listen and be enriched by the word of God`}
                background={[ AudioImage ]}
                buttons={[ { url: '/media/audio', special: false, text: 'Listen',  style: 'transparent-button' } ]}
                tint={0.7}
                blur={0.05}
                alt

            />

            <BannerSection banners={banners} />
            
        </div>
    )
}

export default MediaPage